import React, { Component, Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form } from 'informed'

import StatisticsWrapper from './StatisticsWrapper'
import { DataTable } from 'components//DataTable'
import { CellFooter } from 'components//DataTable/components'
import WrapperRelatedTables from './helperComponents/WrapperRelatedTables'
import { Text, Select, Checkbox, DateTimePicker, FieldList } from 'components/forms'
import Button from 'components/Button'
import Card from 'components/Card'
import Divider from 'components/Divider'
import tableDataGenerator from 'helpers/tableDataGenerator'

import './statistics.scss'

const mainCols = [
		{ Header: 'Nummer', accessor: 'number' },
		{ Header: 'Kartename', accessor: 'cardName' },
		{ Header: 'Datum', accessor: 'date' },
		{ Header: 'Zeit', accessor: 'time' },
		{ Header: 'Kasse', accessor: 'cashbox' },
		{ Header: 'Beleg-Nr.', accessor: 'checkNum' },
		{ Header: 'Umsatz', accessor: 'sales' }
	],
	secondaryCols = [
		{ Header: 'Menge', accessor: 'amount', width: 'auto', Footer: (<span>Insgesamt:</span>) },
		{ Header: 'Nummer', accessor: 'number', width: 'auto' },
		{ Header: 'Bezeichnung', accessor: 'designation', width: 'auto' },
		{ Header: 'Preis', accessor: 'price', width: 'auto' },
		{ Header: '%', accessor: 'percents', width: 'auto' },
		{ Header: 'Im Haus', accessor: 'inHouse', width: 'auto', Cell: () => <Checkbox noForm />, Footer: <Checkbox noForm /> },
		{ Header: 'MWSt.', accessor: 'vat', width: 'auto' },
		{ Header: 'Umsatz', accessor: 'sales', width: 'auto', Footer: ({ data }) => <CellFooter allData={data} colName='sales' /> }
	]

class Cards extends Component {
	state = {
		showStatistics: false,
		values: {}
	}

	handlerDataStatisticsSubmit = () => {
		this.setState({ showStatistics: true })
	}

	handleAddFieldListItem = (field, items, valFromOptions = true) => {
		const { values } = this.state,
			newValues = items.map((item, i) => {
				let formData
				if(valFromOptions) {
					// formData = itemInArrObjsByValue(item, dataProductList(20), 'id')
				} else {
					const strVal = typeof item === 'object' ?
						Object.values(item).join(' - ') : item

					formData = { id: Math.floor(Math.random() * 100), value: strVal }
				}

				return formData
			})

		this.setState({
			values: {
				...values,
				[field]: valFromOptions ? newValues : [...values[field] || [], ...newValues]
			}
		})
	}

	handleDelFieldListItem = ({ field, value }) => {
		this.setState({
			values: {
				...this.state.values,
				[field]: this.state.values[field].filter(item => item.id !== value)
			}
		})
	}

	render({ values } = this.state) {
		const formStatistics = (
			<Form render={({ formApi }) => (
				<Fragment>
					<Row>
						<Col xs={2}>
							<DateTimePicker field='date' label='Bereich' />
							<Checkbox field='user' label='Benutzer anzeigen' />
						</Col>
						<Col xs={2}>
							<DateTimePicker
								field='timePeriod'
								label={{ from: 'Von', to: 'Bis' }}
								interval
								inRow={false}
								picker='time' />
						</Col>
						<Col xs={3}>
							<Select field='type' label='Art' />
							<Select field='real' label='Gültig' />
						</Col>
						<Col xs={3}>
							<Select field='group' label='Gruppe' />
							<Select field='discountNum' label='Rabattnummer' />
						</Col>
						<Col>
							<Text field='cardNum' label='Kartennummer' placeholder='Eintragen' shrink />
						</Col>
					</Row>
					<Divider visible />
					<Row className='statistics-form-card'>
						<Col xs={3}>
							<Card
								id='cashBoxList'
								label='Kassen'
								noDataText='Kassen abwesend'
								listContent
								modal={{
									content: <React.Fragment />,
									width: 820
								}}>
								{(values.cashBoxList && values.cashBoxList.length) &&
									<FieldList listItems={values.cashBoxList} field='cashBoxList' onDelItem={this.handleDelFieldListItem} />
								}
							</Card>
						</Col>
					</Row>
					<Divider />
					<Button onClick={this.handlerDataStatisticsSubmit} text='Berechnen' status='primary' />
				</Fragment>
			)}/>
		)

		return(
			<StatisticsWrapper statisticsData={formStatistics} showStatistics={this.state.showStatistics} switchLabel='Erweitern Kundenkarte'>
				{this.state.showStatistics &&
					<div>
						<WrapperRelatedTables>
							{(handleRowSelect, relatedData = [], selectedRow = {}) => (
								<div className='container-related-tables'>
									<div className='related-col col-main' style={{ flexBasis: '52.21%' }}>
										<DataTable
											data={tableDataGenerator(mainCols, 20)}
											columns={mainCols}
											selectRow
											onRowClick={handleRowSelect}
											withSearch
											withColFilter
											style={{ height: '594px' }} />
									</div>
									<div className='related-col col-secondary'>
										<div className='secondary-table-info'>
											<div className='container-info-title'>
												<span className='title-label'>Kartename:</span> {selectedRow.cardName || ''}
											</div>
										</div>
										<DataTable
											data={relatedData || []}
											columns={secondaryCols}
											withSearch />
									</div>
								</div>
							)}
						</WrapperRelatedTables>
						<Divider />
						<div>
							<Button text='export in excel' status='transparent' />
							<Button text='Vorschau' status='primary' />
							<Button text='grafisch' status='primary' />
						</div>
					</div>
				}
			</StatisticsWrapper>
		)
	}
}

export default Cards
